import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class RewardsDataService {

    REWARDS_ITEMS = [
        {
            title: this.getTranslatedLabel('rewards.Accede_a_eCosentino'),
            subtitle: this.getTranslatedLabel('rewards.WeRewardsAccessECosentino'),
            icon: 'shopping-cart',
            btnName: this.getTranslatedLabel('rewards.Ir_a_E_Cosentino'),
            code_link: 'e-cosentino', // userInfo.mainMenu.e-cosentino
            showButton: false,
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/home-EN1.png'
        },
        {
            title: this.getTranslatedLabel('rewards.WeRewardsTableProfessionalPlatform'),
            subtitle: this.getTranslatedLabel('rewards.WeRewardsAccessProfessionalPlatform'),
            icon: 'city',
            showButton: false,
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/ORL57M11.png'
        },
        {
            title: this.getTranslatedLabel('benefits_we.benefits_clientes_potenciales'),
            subtitle: this.getTranslatedLabel('rewards.WeRewardsPotentialClientsDescription'),
            icon: 'clients',
            showButton: false,
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/potentialClients.png'
        },
        {
            title: this.getTranslatedLabel('rewards.WeRewardsTableFinancialPortal'),
            subtitle: this.getTranslatedLabel('rewards.WeRewardsQuotingAndRatesDescription'),
            icon: 'sales',
            btnName: this.getTranslatedLabel('rewards.WeRewardsTableFinancialPortal'),
            code_link: 'my-financial-portal', // userInfo.mainMenu.my-financial-portal
            showButton: false,
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/difusionProyectos.png'
        },
        {
            title: this.getTranslatedLabel('rewards.WeRewardsTableQuotingAndRates'),
            subtitle: this.getTranslatedLabel('rewards.WeRewardsQuickQuote'),
            icon: 'quoting',
            showButton: false,
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/PIETRA343x300%402x.png'
        },
        {
            title: this.getTranslatedLabel('rewards.WeRewardsTableCaseLogging'), //my claims
            subtitle: this.getTranslatedLabel('rewards.WeRewardsMoreVisibilityDescription'),
            icon: 'alert',
            btnName: this.getTranslatedLabel('rewards.AccedeFabricator'),
            code_link: 'my-claims',
            showButton: false,
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/accesoEventos.png'
        },
        {
            title: this.getTranslatedLabel('benefits_we.benefits_mas_visibilidad'),
            subtitle: this.getTranslatedLabel('rewards.WeRewardsMoreVisibilityDescription'),
            icon: 'recompensas',
            showButton: false,
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/beneficios-mobile-premium.png'
        },
        {
            title: this.getTranslatedLabel('benefits_we.benefits_sample_request'),
            subtitle: this.getTranslatedLabel('rewards.WeRewardsSampleRequestDescription'),
            icon: 'samples',
            showButton: false,
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/muestras3-1.png'
        },
        {
            title: this.getTranslatedLabel('rewards.WeRewardsTableDisplayPolicy'),
            subtitle: this.getTranslatedLabel('rewards.WeRewardsDisplayPolicyDescription'),
            icon: 'exposicion',
            showButton: false,
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/materialExposiciones.png'
        },
        {
            title: this.getTranslatedLabel('benefits_we.benefits_herramientas_marketing'),
            subtitle: this.getTranslatedLabel('rewards.WeRewardsMarketingToolsDescription'),
            icon: 'documents',
            showButton: false,
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/doc-tec3.png'
        },
        {
            title: this.getTranslatedLabel('rewards.WeRewardsWePromote'),
            subtitle: this.getTranslatedLabel('rewards.WeRewardsWePromoteDescription'),
            icon: 'mypromotions',
            showButton: false,
            btnName: this.getTranslatedLabel('rewards.AccedeFabricator'),
            code_link: 'we_promote',
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/newsPortal/WePromoteBanner.png'
        },
        {
            title: this.getTranslatedLabel('rewards.WeRewardsTableFindYourBusiness'),
            subtitle: this.getTranslatedLabel('rewards.WeRewardsFindYourBusinessDescription'),
            icon: 'city',
            showButton: false,
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/cosentinoCity.png'
        },
        {
            title: this.getTranslatedLabel('rewards.WeRewardsCoursesAndEvents'),
            subtitle: this.getTranslatedLabel('rewards.WeRewardsCoursesAndEventsDescriptions'),
            icon: 'visit',
            showButton: false,
            btnName: this.getTranslatedLabel('rewards.Haz_una_reserva_p'),
            code_link: 'we_cosentino_events',
            backgroundImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/cosentino100.png'
        }
    ];

    constructor(private ts : TranslateService) {}

    private translations(){
        this.ts.get([
            'rewards.Accede_a_eCosentino',
            'rewards.WeRewardsAccessECosentino',
            'rewards.Ir_a_E_Cosentino',
            'rewards.WeRewardsTableProfessionalPlatform',
            'rewards.WeRewardsAccessProfessionalPlatform',
            'benefits_we.benefits_clientes_potenciales',
            'rewards.WeRewardsPotentialClientsDescription',
            'rewards.WeRewardsTableFinancialPortal',
            'rewards.WeRewardsQuotingAndRatesDescription',
            'rewards.WeRewardsTableQuotingAndRates',
            'rewards.WeRewardsQuickQuote',
            'rewards.WeRewardsTableCaseLogging', 
            'rewards.WeRewardsMoreVisibilityDescription',
            'rewards.AccedeFabricator',
            'benefits_we.benefits_mas_visibilidad',
            'benefits_we.benefits_sample_request',
            'rewards.WeRewardsSampleRequestDescription',
            'rewards.WeRewardsTableDisplayPolicy',
            'rewards.WeRewardsDisplayPolicyDescription',
            'benefits_we.benefits_herramientas_marketing',
            'rewards.WeRewardsMarketingToolsDescription',
            'rewards.WeRewardsWePromote',
            'rewards.WeRewardsWePromoteDescription',
            'rewards.WeRewardsTableFindYourBusiness',
            'rewards.WeRewardsFindYourBusinessDescription',
            'rewards.WeRewardsCoursesAndEvents',
            'rewards.WeRewardsCoursesAndEventsDescriptions',
            'rewards.Haz_una_reserva_p'
        ])
    }

    getRewardsItems(): Observable<any[]> {
        return of(this.REWARDS_ITEMS);
    }

    getTranslatedLabel(key: string): string {
        return this.ts.instant(key);
    }
}
